import { timeAMPMToTime, getTodaysDate, newTimeList, getAllPackageIdsForRental, pushDataToCommonRecentSearch, getRecentSearches } from './../../../config/utils';
import { ThunkAction, ThunkDispatch } from 'redux-thunk';
import { AppState } from '../../../../store';
import { AnyAction } from 'redux';
import megatron from '../../../../../utils/megatron/megatron';
import { bluSmartTgpApi, hourlyRentalsDetails, HR_PACKAGE_IDS, srp, tripAttr } from '../../../config/constants';
import { generateTimeList, parseForReviewTimeField } from '../../../config/utils';
import dateformat from 'dateformat';
import addDays from '../../../../../utils/date-utils/addDays';
import { BLU_SMART_TGP_MODAL, HOURLY_RENTALS_DETAILS, UPDATE_AIRPORT_DESTINATION_LAT_LONG, UPDATE_AIRPORT_SOURCE_LAT_LONG, UPDATE_HR_PACKAGE, UPDATE_OS_DESTINATION_LAT_LONG, UPDATE_OS_SOURCE_LAT_LONG } from './action-types';
import { getter } from '../../../utils/storage';

export const fetchResults = ({dispatchSearchId = ''}): ThunkAction<
  void,
  AppState,
  {},
  AnyAction
> => {
  return async (
    dispatch: ThunkDispatch<AppState, {}, AnyAction>,
    getState: () => AppState
  ) => {
    if(!dispatchSearchId){
      dispatch({
        type: 'CLEAR_RESULTS'
      });
    }
		const url = `${__ENV_CONFIG__['__GOCARS__']}${srp}`;
		const { common = {}, srp: srpSresults  = {} } = getState();
		const { source = {}, destination = {}, endDate = {}, startDate = {}, tripType = {}, sem_flow = false, isSeo = false, package_id = "", hrPackageDetails = {}, stopOvers = [], configData = {}, flow = '' } = common;
		const { date: sd = new Date(), time: sTime = '' } = startDate;
    const { date: ed = new Date(), time: eTime = '' } = endDate;
		const { place_id: destination_id = '', name: destination_name = '' } = destination;
    const { place_id: source_id = '', name: source_name = '' } = source;
    const { rt_revamp_web: { show_revamp_rt_dweb = false } = {} } = configData;
    const newDate = timeAMPMToTime(sd, sTime);
    const isTimePassed = new Date() >= newDate ? getTodaysDate() : sd;
    const newTime = generateTimeList(isTimePassed.getHours(),  isTimePassed.getMinutes());
    const newSTime = new Date() >= newDate ? newTime[0] : sTime;
    const newETime = new Date() >= newDate ? newTime[1]: eTime;
    const { filters = {} } = srpSresults;
    const headers = {
			Authorization: "Basic Zm9vOmJhcg==",
			'content-type': 'application/json'
		};
		const data = {
			source_name,
			source_id,
			start_time: `${dateformat(sd, 'yyyy-mm-dd')} ${parseForReviewTimeField(newSTime)}`,
			end_time: tripType?.rf === 'rt' || (tripType?.rf === "ow" && stopOvers.length) ? `${dateformat(ed, 'yyyy-mm-dd')} ${parseForReviewTimeField(newETime)}` : "",
			trip_type: tripType?.name,
			flavour: "cars_dweb",
			rf: tripType?.rf,
			channel_type: "",
			call_source: "GOCARS",
			device_id: "dummy",
			search_id: dispatchSearchId,
      vehicle_key: "",
      filter_data: filters,
      sem_flow,
      seo_flow: isSeo,
      source_city_name: source?.city_name,
      destination_city_name: destination?.city_name,
      flow_name: flow?.length ? flow : "direct-cabs",
		}
    if(show_revamp_rt_dweb && tripType?.rf === 'rt' ){ 
      data['end_time'] = `${dateformat(ed, 'yyyy-mm-dd')}`
    }
    if (tripType?.rf !== 'hr') {
      data['destination_id']    = destination_id,
			data['destination_name']  = destination_name
    }

    if (tripType?.rf === 'hr') {
      data['package_id'] = package_id
      data['hourly_rental'] = hrPackageDetails?.packages?.length ? getAllPackageIdsForRental(hrPackageDetails?.packages) : getter(HR_PACKAGE_IDS)
    }

    if (stopOvers.length && tripType?.rf !== 'hr' && tripType?.rf !== 'at') {
      const stops = stopOvers.map((item) => {
        return {name : item?.value?.name, place_id: item?.value?.place_id, city_name: item?.value?.city_name}
      })
      data['stop_overs'] = stops
    }
    const recentSearchRequiredData = getRecentSearches({ type: tripType?.rf });
    if(recentSearchRequiredData.length){
      const { startDate, endDate, triptype, source, destination, package_id = '' } = recentSearchRequiredData[0]
      const requiredData = { 
        startDate, 
        endDate, 
        triptype, 
        source, 
        destination, 
        hrSelectedPackageId: package_id,
        isSeo, 
        sourceLocusDetails: source?.locus || {},
        destinationLocusDetails:  destination?.locus || {}
      }
      pushDataToCommonRecentSearch(requiredData);
    }
    try {
      const response = await megatron({
        name: 'cars Results',
        type: 'POST',
        credentials: 'include',
        url,
        requestData: JSON.stringify(data),
        headers
      });
      dispatch({
        type: 'UPDATE_RESULTS',
        results: response
      });

      const sourceKey = data?.rf === "at" ? "airport_source_lat_long" : "os_source_lat_long" 
      const destinationKey = data?.rf === "at" ? "airport_destination_lat_long" : "os_destination_lat_long"
  
      dispatch({
        type: data?.rf === "at" ? UPDATE_AIRPORT_SOURCE_LAT_LONG : UPDATE_OS_SOURCE_LAT_LONG,
        [sourceKey]: response?.common_data?.source_lat_long
      });
  
      dispatch({
        type: data?.rf === "at" ? UPDATE_AIRPORT_DESTINATION_LAT_LONG : UPDATE_OS_DESTINATION_LAT_LONG,
        [destinationKey]: response?.common_data?.destination_lat_long
      });

      const { common_data = {} } = response || {};
      const { start_time = '', end_time = '', package_id = '', trip_type = "" } = common_data;
      if (tripType?.rf === 'hr' && package_id) {
        dispatch({
          type        : UPDATE_HR_PACKAGE,
          package_id  : package_id || ""
        })
      }
      if(tripType.name !== trip_type){
        dispatch({
          type: "UPDATE_TRIP_TYPE",
          tripType: {
            name: trip_type,
            rf: tripAttr[trip_type].rf,
          }
        })
      }
      if (start_time) {
        const nTime = newTimeList(new Date(start_time).getHours(), new Date(start_time).getMinutes());
        if (nTime[0]) {
          const sD = {
            date: new Date(start_time),
            time: nTime[0],
          };
          let newendTime = nTime[1] ? nTime[1] : nTime[0];
          if (end_time) {
            newendTime = newTimeList(new Date(end_time).getHours(), new Date(end_time).getMinutes())[0];
          }
          const eDate = new Date(start_time) >= new Date(ed) ? addDays(new Date(start_time), 1): new Date(ed);
          const eD = {
            date: end_time ? new Date(end_time) : eDate,
            time: newendTime
          };
          dispatch({
            type: 'UPDATE_RECENT_SEARCH',
            data: {
              startDate: sD,
              endDate: eD
            }
          });
        }
      }
    } catch (err) {
      console.info("err", err);
    }
  };
};

// calling pageMaker api for bluSmart tgp modal data
export const fetchBluSmartTgpModalData = (): ThunkAction<
  void,
  AppState,
  {},
  AnyAction
> => {
  return async (
    dispatch: ThunkDispatch<AppState, {}, AnyAction>,
  ) => {
    const url = `${__ENV_CONFIG__['__VOYAGER__']}${bluSmartTgpApi}`;
    try {
      const respJson : any = await megatron({
        name: 'cars_bluSmart_tgp',
        type: 'GET',
        credentials: 'same-origin',
        url,
      });

      const responseData = respJson?.data?.ryde_revamp_srp_data?.template?.blueSmartData;
      dispatch({
        type: BLU_SMART_TGP_MODAL,
        bluSmartTgp: responseData || {}
      });
    } catch (err) {
      console.info("err", err);
    }
  };
};

export const fetchHourlyRentalDetails = (): ThunkAction<
  void,
  AppState,
  {},
  AnyAction
> => {
  return async (
    dispatch: ThunkDispatch<AppState, {}, AnyAction>,
    getState: () => AppState
  ) => {
    const url = `${__ENV_CONFIG__['__GOCARS__']}${hourlyRentalsDetails}`;
    const { common = {} } = getState();
		const { source = {}, endDate = {}, startDate = {}, tripType = {}, sem_flow = false, isSeo = false, package_id = "", hrPackageDetails = {} } = common;
		const { date: sd = new Date(), time: sTime = '' } = startDate;
    const { date: ed = new Date(), time: eTime = '' } = endDate;
    const { place_id: source_id = '', name: source_name = '' } = source;
    const newDate = timeAMPMToTime(sd, sTime);
    const isTimePassed = new Date() >= newDate ? getTodaysDate() : sd;
    const newTime = generateTimeList(isTimePassed.getHours(),  isTimePassed.getMinutes());
    const newSTime = new Date() >= newDate ? newTime[0] : sTime;
    const newETime = new Date() >= newDate ? newTime[1]: eTime;
    const headers = {
			Authorization: "Basic Zm9vOmJhcg==",
			'content-type': 'application/json'
		};

    const packages = hrPackageDetails?.packages || []
    const hourly_rental = [] 
    packages.forEach(item => hourly_rental.push(item.name))

    const data = {
			source_name,
			source_id,
			start_time: `${dateformat(sd, 'yyyy-mm-dd')} ${parseForReviewTimeField(newSTime)}`,
			end_time: tripType?.rf === 'rt' ? `${dateformat(ed, 'yyyy-mm-dd')} ${parseForReviewTimeField(newETime)}` : "",
			trip_type: tripType?.name,
			flavour: "cars_dweb",
			rf: tripType?.rf,
			channel_type: "",
			call_source: "GOCARS",
			device_id: "dummy",
      vehicle_key: "",
      hourly_rental,
      sem_flow,
      package_id: package_id,
      seo_flow: isSeo
		}

    try {
      const respJson : any = await megatron({
        name: 'cars_hr_details',
        type: 'POST',
        credentials: 'include',
        url,
        requestData: JSON.stringify(data),
        headers
      });
      const responseData = {
        rentalPackages : respJson?.hourly_rental || [], 
        selectedPackageId : respJson?.selected_package_id || {}
      };
      dispatch({
        type: HOURLY_RENTALS_DETAILS,
        hourlyRentalDetails: responseData || {}
      });
    } catch (err) {
      console.info("err", err);
    }
  };
};
